import { Component, EventEmitter, forwardRef, Input, Optional, Output } from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-imperia-select',
  templateUrl: './imperia-select.component.html',
  styleUrls: ['./imperia-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImperiaSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class ImperiaSelectComponent implements ControlValueAccessor {

  // UI Inputs
  @Input() matLabel: string = '';
  @Input() spinnerLoading: boolean = false;
  @Input() multiSelect: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() optionAll: boolean = false;
  @Input() toUpperCase: boolean = false;

  // Data Inputs
  @Input() options: any[] = [];
  @Input() displayKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Input() searchCriteria: string = '';

  // Form Inputs
  @Input() formControl?: AbstractControl;   // supports FormControl or AbstractControl
  @Input() formControlName?: string;        // supports formControlName inside FormGroup

  @Output() toggleAll = new EventEmitter<boolean>(); // emit when "All" clicked
  @Output() selectionChange = new EventEmitter<any>(); // emit when selection changes

  // Variables for ControlValueAccessor
  value: any;
  onChange = (_: any) => {};
  onTouched = () => {};

  constructor(@Optional() private readonly controlContainer: ControlContainer) {}

  onSelectionChange(event: any) {
    this.selectionChange.emit(event);
  }

  get control(): FormControl | null {
    if (this.formControl) {
      return this.formControl as FormControl;
    }
    if (this.formControlName && this.controlContainer?.control) {
      return this.controlContainer.control.get(this.formControlName) as FormControl;
    }
    return null;
  }

  // Called by Angular to write value to the view
  writeValue(obj: any): void {
    this.value = obj;
  }

  // Register change callback
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Register touched callback
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
}
